//**auto-generated don't edit this code**//
export enum FlashCardsPerPage {
	Six,
	Nine,
	Twelve,
}